
import {
  defineComponent, ref,
} from 'vue';

import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import TipoContatoModal from '@/views/Cadastros/Pessoas/TiposContatos/TipoContatoModal.vue';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import ServicoTipoContato from '@/servicos/Cadastros/Pessoas/ServicoTipoContato';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';

export default defineComponent({
  name: 'TipoContato',
  components: {
    TelaPadraoCrud,
    TipoContatoModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoTipoContato = new ServicoTipoContato();
    const refCrudTipoContato = ref<InstanceType<typeof TelaPadraoCrud>>();
    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = true;
    crudBase.estrutura.verificarCadastroCompartilhado = true;
    crudBase.estrutura.botaoPrincipalAcao = 'Novo';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão do tipo';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Descrição', dataIndex: 'descricao', key: 'DescricaoTipoContato', position: 0, visible: true, ordering: true, fixed: 'left', align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Código', dataIndex: 'codigo', key: 'CodigoTipoContato', position: 1, visible: false, ordering: true,
      },
      {
        title: 'Status', dataIndex: 'ativo', key: 'AtivoTipoContato', position: 2, visible: true, width: 100, align: 'left', customRenderRow: ECustomRenderRow.TagAtivo,
      },
      {
        title: 'Ações', key: 'acoes', position: 7, visible: true, fixed: 'right', width: 100, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'Codigo', ordem: 'DESC' } as IOrdenacao);

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrudTipoContato.value !== undefined) {
        await refCrudTipoContato.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }
    return {
      crudBase,
      servicoTipoContato,
      refCrudTipoContato,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
    };
  },
});
